// @flow
export const ROOT_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const INTRO_ROUTE = '/intro';
export const GROUP_EXAMPLE_ROUTE = `/groups/:id`;
